import type { CommentAnalysis, YouTubeComment } from './model';

const STOPWORDS = new Set([
  'about', 'after', 'again', 'also', 'because', 'been', 'being', 'could', 'does',
  'from', 'have', 'here', 'just', 'like', 'more', 'most', 'only', 'really', 'that',
  'their', 'there', 'these', 'they', 'this', 'video', 'what', 'when', 'where', 'which',
  'with', 'would', 'your', 'youre',
]);

export const buildSwitchQuery = (competitor: string): string => {
  const value = competitor.trim();
	return `"switching from ${value}" OR "switched from ${value}" OR "leaving ${value}" OR "moving away from ${value}"`;
};

export const redditThreadUrl = (permalink: string): string =>
  permalink.startsWith('/') ? `https://www.reddit.com${permalink}` : 'https://www.reddit.com';

export const safeExternalUrl = (value: string): string | undefined => {
  try {
    const url = new URL(value);
    return url.protocol === 'https:' || url.protocol === 'http:' ? value : undefined;
  } catch {
    return undefined;
  }
};

export const isWebsiteInput = (value: string): boolean => {
	const clean = value.trim();
	if (!clean || /\s/.test(clean)) return false;
	try {
		const url = new URL(clean.includes('://') ? clean : `https://${clean}`);
		return (url.protocol === 'https:' || url.protocol === 'http:') && url.hostname.includes('.');
	} catch {
		return false;
	}
};

export const analyzeComments = (comments: YouTubeComment[]): CommentAnalysis => {
  const counts = new Map<string, number>();
  for (const comment of comments) {
    const words = comment.text.toLowerCase().match(/[a-z0-9']+/g) ?? [];
    for (const raw of words) {
      const word = raw.replace(/'/g, '');
      if (STOPWORDS.has(word)) continue;
      counts.set(word, (counts.get(word) ?? 0) + 1);
    }
  }
  return {
    totalComments: comments.length,
    totalLikes: comments.reduce((sum, comment) => sum + comment.likes, 0),
    questions: comments.filter((comment) => comment.text.includes('?')).length,
    terms: [...counts.entries()]
      .filter(([, count]) => count > 1)
      .map(([term, count]) => ({ term, count }))
      .sort((a, b) => b.count - a.count || a.term.localeCompare(b.term)),
    topThreads: [...comments].sort((a, b) => b.likes - a.likes || a.id.localeCompare(b.id)),
  };
};
